module.exports = __webpack_public_path__ + "assets/img/00022ec49876932cd16c26ae1072426f.png";